module.exports = __webpack_public_path__ + "4ad42ec3beef1f35b2cc6fd1ce6ab104.MP3";